function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCallTelephoneSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.998 511.998",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48A0DC"
    },
    d: "M370.187,0c-78.009,0-141.241,63.232-141.241,141.241c0,24.444,6.215,47.431,17.143,67.487 l-17.143,73.754l69.12-19.959c21.124,12.588,45.736,19.959,72.121,19.959c78.009,0,141.241-63.232,141.241-141.241 S448.196,0,370.187,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "369.995,44.138 273.086,141.241 299.569,167.724 369.995,97.103 370.189,97.298  370.375,97.103 440.81,167.724 467.293,141.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8E6E6"
    },
    points: "370.085,97.103 317.217,150.069 317.217,220.69 423.148,220.69 423.148,150.069  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FBA6F"
    },
    d: "M232.521,460.714c12.297,12.341,25.971,23.367,41.234,31.762 c51.288,28.204,104.139,29.202,152.717-19.368l22.387-22.396c10.778-10.779,13.268-27.321,6.144-40.792 c-16.764-31.665-78.557-67.884-78.557-67.884c-13.983-7.98-30.861-8.863-38.841,5.349c0,0-20.074,24.082-25.185,27.542 c-23.331,15.81-44.941,15.192-66.754-6.621l-50.706-50.706l-50.697-50.697c-21.813-21.813-22.431-43.423-6.621-66.754 c3.46-5.111,27.542-25.185,27.542-25.185c14.212-7.989,13.321-24.858,5.35-38.841c0,0-36.22-61.793-67.884-78.557 c-13.471-7.124-30.014-4.634-40.792,6.144L39.462,86.097c-44.968,44.977-47.448,93.617-25.185,141.286 c9.031,19.332,22.078,36.511,37.138,51.624L232.521,460.714z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37914E"
    },
    d: "M344.284,423.724c-0.3,0-0.609-0.009-0.918-0.044c-60.902-6.321-100.228-45.038-101.87-46.68 c-3.443-3.443-3.443-9.022,0-12.473c3.443-3.443,9.022-3.46,12.482-0.018c0.362,0.362,36.74,35.955,91.207,41.604 c4.846,0.512,8.377,4.846,7.874,9.693C352.582,420.352,348.751,423.724,344.284,423.724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37914E"
    },
    d: "M150.624,282.483c-1.951,0-3.919-0.653-5.561-1.977c-2.048-1.677-50.37-41.631-56.744-103.044 c-0.503-4.846,3.028-9.19,7.874-9.693c4.882-0.521,9.19,3.028,9.693,7.874c5.597,53.998,49.885,90.809,50.335,91.171 c3.769,3.09,4.334,8.642,1.254,12.42C155.727,281.37,153.184,282.483,150.624,282.483"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallTelephoneSvgrepoCom);
export default __webpack_public_path__ + "static/media/phone-call-telephone-svgrepo-com.c412d78fc07f2475c80b896c825bee43.svg";
export { ForwardRef as ReactComponent };